import { RestCRUDService } from '../common/rest/RestCRUDService';
import { CRUDServiceType } from '../common/service/CRUDServiceType';
import { IUserEntityModel } from './IUserEntityModel';
import { IUserEntitySearch } from './IUserEntitySearch';
import { IUserEntityService } from './IUserEntityService';
import { UserSourceType } from './UserSourceType';

export class RestUserEntityService
  extends RestCRUDService<IUserEntityModel, IUserEntitySearch>
  implements IUserEntityService
{
  private sourceTypeTranslateMap = {
    [UserSourceType.activeDirectory]: 'Active Directory',
    [UserSourceType.internal]: 'Локальный',
    [UserSourceType.sso]: 'SSO',
  };

  constructor(private type: CRUDServiceType) {
    super();
  }

  translateSourceType(type: UserSourceType): string {
    return this.sourceTypeTranslateMap[type] || 'неизвестный тип';
  }

  async getUserLoginsAndRoles(): Promise<any[]> {
    const adminEndpoint = `${this.config.url.api.admin}/user`;
    return await fetch(adminEndpoint + '/loginsAndRoles', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    }).then((res) => res.json());
  }

  async updateSsoUserRole(userId: string, systemRoleId: string): Promise<string> {
    const result = await this.request()
      .url(`${this.getEndpoint()}/sso/${userId}/role-update`)
      .patch({ systemRoleId })
      .json<{ state: string; id: string }>()
      .catch(this.handleError);
    return result.id;
  }

  getEndpoint(): string {
    const url = this.config.url.api[this.type];
    return `${url}/user`;
  }
}
